<template>
<div container--fluid>
    <v-layout>
        <TeamDetailModule :team-tid="team_id"></TeamDetailModule>
    </v-layout>
</div>
</template>

<script>
import TeamDetailModule from '@modules/team/detail.vue';

export default {
    name: 'teamDetail',
    components: {
        TeamDetailModule,
    },
    props: {
        'team_id': {
            type: [Number, String],
            required: true
        }
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
